import { Helmet } from 'react-helmet'
import { getStepNumber } from 'config/onboarding'
import { getTitle } from 'config/titles'
import Onboarding from 'components/Onboarding'
import { useNetwork } from '~/networkProvider'
import { FacilityScreenContainer } from '~/components/FacilityScreenContainer'

const OnboardingCeilingsScreen = () => {
  const { online } = useNetwork()
  return (
    <FacilityScreenContainer>
      <Helmet>
        <title>{getTitle('ceilings')}</title>
      </Helmet>
      <Onboarding
        online={online}
        step={getStepNumber('Ceilings')}
        message="Draw and configure the ceilings of your facility."
      />
    </FacilityScreenContainer>
  )
}

export default OnboardingCeilingsScreen
